import { TileMapLayerView } from "core/tiles";
export class Map3dLayerView extends TileMapLayerView {
    constructor(map, layer, display, source) {
        super(layer, display, source);
        this._map = map;
    }
    get map() {
        return this._map;
    }
}
//# sourceMappingURL=map.layer.view.js.map